import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import * as _ from 'lodash';
import { AllDashboardServiceProxy, TeamMemberDto } from '../../../../../shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'app-team-member-section',
    templateUrl: './team-member-section.component.html',
    styleUrls: ['./team-member-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamMemberSectionComponent extends AppComponentBase implements OnInit {
    teamMembersDetails: TeamMemberDto[];
    isLoaded = false;
    isTeamDataempty = true;
    dateTime = new Date();
    constructor(private _monitorService: MonitoringService, injector: Injector, private _AllDashboardServiceProxy: AllDashboardServiceProxy, private router: Router) { super(injector); }
    ngOnInit(): void {
        this.getAllTeamMembers();
    }
    getAllTeamMembers() {
        this._monitorService.logTrace("UI-getAllTeamMembers", { "getAllTeamMembers ": "GetTeamMember: " + this.dateTime });
        this._AllDashboardServiceProxy.getTeamMember().subscribe(result => {
            this.teamMembersDetails = [];
            result = _.orderBy(result, ['userJoinDate'], ['desc']);
            result?.forEach(x => {
                if (x.userProfileImage === '' || x.userProfileImage === 'undefined' || x.userProfileImage === null) {
                    x.userProfileImage = 'assets/common/images/default-profile-picture1.svg';
                }
                this.teamMembersDetails.push(x);
                this.isTeamDataempty = false;
            });
            result.forEach(x => {
                x.userRole = x.userRole?.map(x => this.l(x));
            });
            this.isLoaded = true;
            this.markForCheck();
        });
    }
    viewall() {
        this.router.navigate([AppRoutes.admin.users]);
    }
}
